import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/index";
import router from "./router";
import "./plugins/base";
import "./plugins/vee-validate";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "./bootstrap";
import Index from "./App";
import { setBaseUrl } from "./packages/MyAxios";
import "./scaffoldings";
import Notification from "./helpers/Notification";
import * as FilePond from "filepond";
import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);

FilePond.setOptions({
    server: {
        url: "/api",
        process: {
            url: "/media",
            method: "POST",
            withCredentials: false,
            headers: {
                "X-CSRF-TOKEN": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content"),
            },
        },
    },
});
Vue.config.productionTip = false;
store.watch((state) => state.ConfigModule.request.baseUrl, (path) => {
    setBaseUrl(path);
});
Vue.use(VueRouter);

Vue.use(Notification);


new Vue({
    store,
    vuetify,
    i18n,
    render: h => h(Index),
    router,
}).$mount("#app");
